var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentFilter && _vm.currentFilter.filterName)?_c('div',{staticStyle:{"display":"inline","color":"#673AB7"}},[_vm._v(" - "+_vm._s(_vm.currentFilter.filterName)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }